import { MessageCircle } from "lucide-react";
import { whatsappUrl } from "../data/content";

export const FloatingWhatsApp = () => {
    return (
        <a
            href={whatsappUrl()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="floating-whatsapp-btn"
            aria-label="Escribenos por WhatsApp"
            className="pulse-ring group fixed bottom-6 right-6 z-[60] inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_40px_rgba(37,211,102,0.45)] transition hover:scale-110 sm:h-16 sm:w-16"
        >
            <svg viewBox="0 0 32 32" className="h-7 w-7 sm:h-8 sm:w-8" fill="currentColor" aria-hidden="true">
                <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.99 2.722.99.344 0 1.39-.228 1.39-1.477 0-.143-.072-.358-.172-.43-.073-.058-1.174-.617-1.204-.617zM16 0C7.163 0 0 7.163 0 16c0 3.04.846 5.887 2.312 8.323L.262 32l7.78-2.214A15.92 15.92 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.387c-2.85 0-5.52-.87-7.73-2.361l-5.4 1.536 1.56-5.226A13.333 13.333 0 0 1 2.613 16C2.613 8.6 8.6 2.613 16 2.613S29.387 8.6 29.387 16 23.4 29.387 16 29.387z" />
            </svg>
            <span className="absolute right-full mr-3 hidden rounded-lg bg-black px-3 py-2 text-xs font-semibold text-white shadow-lg group-hover:block whitespace-nowrap">
                Reserva tu serenata
                <span className="absolute right-[-4px] top-1/2 -translate-y-1/2 h-2 w-2 rotate-45 bg-black" />
            </span>
        </a>
    );
};

export default FloatingWhatsApp;
